import classnames from 'classnames'
import { useState, useRef, useEffect } from 'react'

export default function Prefilled({ error, onEdit, ...inputProps }) {
  const inputElemRef = useRef()
  const [isEditable, setIsEditable] = useState(false)

  const handleEditClick = () => {
    setIsEditable(true)

    if (onEdit) onEdit()
  }

  const handleBlur = () => {
    setIsEditable(false)

    inputProps.onBlur && typeof inputProps.onBlur === 'function' && inputProps.onBlur()
  }

  useEffect(() => {
    if (isEditable) {
      inputElemRef.current.focus()
    }
  }, [isEditable])

  return (
    <div className={classnames('inputContainer flex alignCenter', { error })}>
      <input {...inputProps} disabled={!isEditable} ref={inputElemRef} onBlur={handleBlur} />
      {!isEditable && (
        <button className='edit' onClick={handleEditClick}>
          Edit
        </button>
      )}

      <style jsx>{`
        .inputContainer {
          position: relative;
          height: 4.2rem;
          border-radius: 2.1rem;
          background: var(--secondary-input-bg);

          input {
            width: 100%;
            height: 100%;
            padding: 0 1.9rem;
            border-radius: inherit;
            outline: none;
            background: transparent;
            border: 0.2rem solid var(--secondary-input-bg);
            font-size: 1.6rem;
            transition: border-color 0.2s;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            &:focus {
              border-color: var(--primary-color);
              color: #000;
            }

            &::placeholder {
              color: var(--secondary-text-color);
            }
          }

          .edit {
            position: absolute;
            top: 50%;
            right: 1.9rem;
            transform: translate(0, -50%);
            color: var(--primary-color);
            line-height: 2.1rem;
            font-size: 1.6rem;
          }

          &.error {
            input {
              border-color: var(--alert-color);
            }
          }
        }

        @media (max-width: 1024px) {
          .inputContainer {
            height: 3.5rem;
            border-radius: 1.8rem;

            input {
              font-size: 1.4rem;
            }
          }
        }
      `}</style>

      <style jsx>{`
        .inputContainer {
          input {
            padding: ${isEditable ? '0 1.9rem' : '0 5rem 0 1.9rem'};
          }
        }
      `}</style>
    </div>
  )
}
